import { Stack, Typography } from '@mui/material';
import { PrimaryButton } from 'components/lib/PrimaryButton';
import { TertiaryButton } from 'components/lib/TertiaryButton';
import { Modal } from 'components/Modal';
import type { NewQuoteWarningModalProps } from './NewQuoteWarningModal.types';

const NewQuoteWarningModal = ({ footerOptions, open, onClose }: NewQuoteWarningModalProps) => {
  const { primaryButton, tertiaryButton } = footerOptions;

  return (
    <Modal
      open={open}
      title="Before You Continue"
      onClose={onClose}
      onCloseIconClick={onClose}
      modalHeaderDisplayItemsReversed
      modalContent={
        <Stack>
          <Typography variant="h2">Starting a new quote will replace your current one.</Typography>
          <Typography variant="body1">
            If you continue, any previous quotes you created will become unavailable and can’t be
            edited. You’ll only be able to make changes to your new quote moving forward.
          </Typography>
        </Stack>
      }
      modalFooter={
        <Stack gap={2} flex={1}>
          <PrimaryButton text={primaryButton.text} onClick={primaryButton.onClickFn} />
          <TertiaryButton text={tertiaryButton.text} underline onClick={tertiaryButton.onClickFn} />
        </Stack>
      }
    />
  );
};

export default NewQuoteWarningModal;
